import "./bootstrap";
import "../css/app.css";
import { createInertiaApp } from "@inertiajs/vue3";
import Lang from "lang.js";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createApp, h } from "vue";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

const messages = window.messages;

const lang = new Lang({
    messages,
    locale: window.locale,
    fallback: window.fallback_locale,
});

const translateJson = (message) => {
    return lang.get("__JSON__." + message);
};

window.trans = lang;
window.__ = translateJson;

import mitt from "mitt";
window.Emitter = mitt();

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob("./Pages/**/*.vue")),
    setup({ el, App, props, plugin }) {
        let app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue);

        app.config.globalProperties.trans = lang;
        app.config.globalProperties.__ = translateJson;

        return app.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
